//=====================================================
//　処理フロー
//=====================================================
import { useContext } from "react";
import { ContentsBox } from "./ContentsBox";
import { ReservationType } from "../utils/ConstCommon";
import { CtxNewReservation } from "../utils/Contexts";

interface IFProps {
    currentProcess: number
}

export enum ProcessName {
    Menu,
    Date,
    Patient,
    Symptoms,
    Confirm,
    Complete
}

export function ReservationFlow(props: IFProps){

    const cnr = useContext(CtxNewReservation);

    let liclass:string[] = new Array(6);
    
    for (let i:number = 0; i <= 5; i++){
        if (i === props.currentProcess){
            liclass[i] = "is-current";
        } else if (i < props.currentProcess){
            liclass[i] = "is-passed";
        }
    }

    return (
        <ContentsBox>
            <ul className="process_flow">
                <li className={liclass[ProcessName.Menu]}>
                    <div className="process_flow-icon"><span className="icon-list"></span></div>
                    <div className="process_flow-text text-s pc-parts">治療メニューを選択する</div>
                    <div className="process_flow-text text-s sp-parts">メニュー選択</div>
                </li>
                <li className={liclass[ProcessName.Date]}>
                    <div className="process_flow-icon"><span className="icon-calendar-select"></span></div>
                    <div className="process_flow-text text-s pc-parts">来院日時を<br/>指定する</div>
                    <div className="process_flow-text text-s sp-parts">日時<br/>指定</div>
                </li>
                {cnr.type === ReservationType.First && 
                <li className={liclass[ProcessName.Patient]}>
                    <div className="process_flow-icon"><span className="icon-pen"></span></div>
                    <div className="process_flow-text text-s pc-parts">患者様情報を<br/>入力する</div>
                    <div className="process_flow-text text-s sp-parts">患者情報入力</div>
                </li>
                }
                <li className={liclass[ProcessName.Symptoms]}>
                    <div className="process_flow-icon"><span className="icon-tooth-black"></span></div>
                    <div className="process_flow-text text-s pc-parts">症状を<br/>入力する</div>
                    <div className="process_flow-text text-s sp-parts">症状<br/>入力</div>
                </li>
                <li className={liclass[ProcessName.Confirm]}>
                    <div className="process_flow-icon icon-size-l"><span className="icon-check-chart"></span></div>
                    <div className="process_flow-text text-s pc-parts">入力内容を<br/>確認する</div>
                    <div className="process_flow-text text-s sp-parts">内容<br/>確認</div>
                </li>
                <li className={liclass[ProcessName.Complete]}>
                    <div className="process_flow-icon icon-size-l"><span className="icon-check-circle"></span></div>
                    <div className="process_flow-text text-s pc-parts">予約完了</div>
                    <div className="process_flow-text text-s sp-parts">予約<br/>完了</div>
                </li>
            </ul>
        </ContentsBox>
    )

}